import { Link } from 'react-router-dom';
import { recommendedComics, statsData } from '@/mocks/homeData';

export default function RecommendSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left - Text */}
          <div className="flex-1 w-full">
            <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
              土豪漫画网致力于为漫画爱好者提供最优质的<strong>免费漫画下拉式</strong>阅读体验。
              我们汇聚了海量<strong>高清韩漫</strong>资源，通过<strong>人气榜</strong>让您轻松发现热门作品，
              无论是最新连载还是经典完结，都能在<strong>韩国漫画在线观看</strong>平台上一网打尽。
            </p>

            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors duration-300 whitespace-nowrap cursor-pointer mb-10"
            >
              探索免费漫画
              <i className="ri-arrow-right-line"></i>
            </Link>

            {/* Stats */}
            <div className="flex items-center gap-12 md:gap-16">
              <div>
                <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                  {statsData.totalComics.toLocaleString()}+
                </div>
                <div className="text-sm text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-12 bg-background-300"></div>
              <div>
                <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                  {statsData.dailyUpdates.toLocaleString()}+
                </div>
                <div className="text-sm text-foreground-500 mt-1">每日更新</div>
              </div>
            </div>
          </div>

          {/* Right - Featured Card */}
          <div className="flex-1 w-full">
            {recommendedComics.filter(c => c.featured).map((comic) => (
              <div
                key={comic.id}
                className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:ml-auto group cursor-pointer"
                data-product-shop
              >
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Badge */}
                <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-background-50 text-foreground-900 text-xs font-semibold">
                  主编力荐
                </div>
                {/* Bottom overlay */}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent pt-20 pb-6 px-6">
                  <h3 className="font-heading text-xl font-bold text-background-50 mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-sm text-background-50/80">
                    已更新至 {comic.latestChapter}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}